const PREFIX = "/analytics/";

export const TRACK_ACTION = PREFIX + "track-action";
